import { render, staticRenderFns } from "./AdminSchedulesBatchModalChangeTherapist.vue?vue&type=template&id=2c1ab595&scoped=true"
import script from "./AdminSchedulesBatchModalChangeTherapist.vue?vue&type=script&lang=js"
export * from "./AdminSchedulesBatchModalChangeTherapist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1ab595",
  null
  
)

export default component.exports